const serverWebsocket = process.env.SERVER_WS_URL;
const localStatusServer = process.env.STATUS_SERVER_URL;
const aiMasteringServer = process.env.AI_MASTERING_URL;
const aiMasteringWebsocketServer = process.env.AI_MASTERING_WS_URL;

const $api = {
  serverWebsocket,
  localStatusServer,
  aiMasteringServer,
  aiMasteringWebsocketServer,
};

export default $api;
